



































import moment from 'moment'
import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'

import ModelSetter from '../../../../../Mixins/ModelSetter'
import { PickerFormat } from '../../../../../components/Picker/types'
import { SelectOption } from '../../../../../logic/types'
import { UseFields } from '../../../../Pi'
import { ActivityCondition, SentCondition } from '../types'

@Component({
  data() {
    return {
      PickerFormat
    }
  }
})
export default class DateTimeValueConditions extends Mixins(UseFields, ModelSetter) {
  @VModel({ type: Object }) condition!: ActivityCondition | SentCondition

  @Prop({ type: Array, required: false, default: () => [] }) selectValueOptions!:Array<SelectOption>

  @Prop({ type: Boolean, default: false }) disabled!: boolean

  state: { conditionValue: null | string } = {
    conditionValue: null
  }

  updateModel():void {
    if (this.state.conditionValue === 'Custom') {
      this.condition.value = moment().add(-1, 'm').format('YYYY-MM-DD HH:mm:ss')
    } else {
      this.condition.value = this.state.conditionValue
    }
  }

  onConditionValueChange():void {
    this.updateModel()
  }

  mounted():void {
    if (this.condition.value !== null) {
      this.state.conditionValue = 'Custom'
    } else {
      this.state.conditionValue = this.condition.value
    }
  }
}
